/**
 * @generated SignedSource<<e1cfb3560194d27e18b4ff1327e67198>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RovoActivationFragment_query$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly activationIdByProduct: {
      readonly active: string | null;
    } | null;
  } | null> | null;
  readonly " $fragmentType": "RovoActivationFragment_query";
};
export type RovoActivationFragment_query$key = {
  readonly " $data"?: RovoActivationFragment_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"RovoActivationFragment_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "cloudId"
    }
  ],
  "kind": "Fragment",
  "name": "RovoActivationFragment_query",
  "selections": [
    {
      "args": [
        {
          "items": [
            {
              "kind": "Variable",
              "name": "cloudIds.0",
              "variableName": "cloudId"
            }
          ],
          "kind": "ListValue",
          "name": "cloudIds"
        }
      ],
      "concreteType": "TenantContext",
      "kind": "LinkedField",
      "name": "tenantContexts",
      "plural": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Literal",
              "name": "product",
              "value": "rovo"
            }
          ],
          "concreteType": "TenantContextActivationId",
          "kind": "LinkedField",
          "name": "activationIdByProduct",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "active"
            }
          ],
          "storageKey": "activationIdByProduct(product:\"rovo\")"
        }
      ]
    }
  ],
  "type": "Query"
};

(node as any).hash = "e251dc1268be3ce22a916f876adab00d";

export default node;
